import { INTERACTIONS_LOCALSTORAGE } from '../constants'
import { setupTime } from './common'

export const getCoresiteInteractions = () =>
  JSON.parse(localStorage.getItem(INTERACTIONS_LOCALSTORAGE) ?? '{}') ?? {}

export const updateCoresiteInteractions = (data: Record<string, unknown>) => {
  const coresiteInteractions = getCoresiteInteractions()

  localStorage.setItem(
    INTERACTIONS_LOCALSTORAGE,
    JSON.stringify({
      ...coresiteInteractions,
      ...data
    })
  )
  setupTime(INTERACTIONS_LOCALSTORAGE)
}
